window.Valence ||= {}
window.Valence.Utils ||= {}

window.Valence.Utils.Visibility = {
  isVisibleByClass(e) {
    return !(e.classList.contains('hidden') || e.classList.contains('!hidden'))
  },
}
